module.exports = __webpack_public_path__ + "static/media/md-arrow-dropleft-circle.34ef1515.svg";